import {usePopper} from "react-popper"
import {createRoot} from "react-dom/client"
import React, {useState} from "react"
import {useOutsideClickListener} from "./hooks"
import {getOrAppend} from "dom_utils"
import classNames from "classnames"

function Popover({
  className,
  target,
  onClose,
  isOpen = false,
  placement = "auto",
  modifiers = [],
  title,
  content,
  cta,
  children
}) {
  // https://reactjs.org/docs/hooks-reference.html#useref
  const [refElement, setRefElement] = useState(null)
  const [arrowElement, setArrowElement] = useState(null)
  useOutsideClickListener(refElement, onClose, {except: target})
  const {styles, attributes} = usePopper(target, refElement, {
    placement,
    modifiers: [
      ...modifiers,
      {name: "arrow", options: {element: arrowElement}},
      {name: "offset", options: {offset: [0, 12]}}
    ]
  })

  if (!isOpen) return null
  return (
    <div
      ref={setRefElement}
      style={styles.popper}
      className={classNames("popover", className)}
      {...attributes.popper}>
      <div
        className="arrow"
        ref={setArrowElement}
        style={styles.arrow}
      />
      {title ? <div className="popover__title">{title}</div> : undefined}
      <div className="popover__content">
        {content ? <p>{content}</p> : undefined}
        {!!cta &&
          <a href={cta.href} onClick={onClose}>
            {cta.title}
          </a>}
        {children}
      </div>
    </div>
  )
}

export function renderPopover(el, options) {
  const component = options.component || Popover
  delete options.component

  const container = getOrAppend("popover_container")
  const root = createRoot(container)

  options.target = el
  options.onClose = () => root.unmount()
  options.isOpen = true
  const popover = React.createElement(component, options)
  root.render(popover)
  return root
}

export default Popover
